import { Controller } from '@hotwired/stimulus';
import { input } from '../../../../libs/cifra/dialogs';

/* global $, I18n, Cifra, set_overlay_ajax */
const SELECTOR_LINEA = '.linea-factura';

export default class extends Controller {
  connect() {
    this.#conectarCodigoViejo();
  }

  #conectarCodigoViejo() {
    this.#conectarFacturaForm();
    this.#conectarDescuentoPorcentaje();
  }

  #conectarDescuentoPorcentaje() {
    this.element.querySelectorAll('.btn-descuento-porcentaje').forEach((element) => {
      element.addEventListener('click', () => {
        input({
          title: I18n.t('porcentaje'),
        }).then((valor) => {
          this.#aplicarDescuentoPorcentaje(element, valor);
        });
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #aplicarDescuentoPorcentaje(boton, valor) {
    if (!valor) {
      return;
    }
    const porcentaje = parseFloat(valor.replaceAll(',', '.'));
    const fila = boton.closest(SELECTOR_LINEA);
    const $importe = $(fila.querySelector('input.i_importe'));
    const $descuento = $(fila.querySelector('input.i_descuento'));
    const precioUnidad = parseFloat($importe.autoNumeric('get'));
    if (!precioUnidad) {
      return;
    }
    const descuento = (precioUnidad * porcentaje) / 100;
    $descuento.autoNumeric('set', descuento);
    // No sé por qué autoNumeric al hacer el set no actualiza el campo oculto
    // Llamamos a change porque autoNumeric no actualiza el campo hidden
    $descuento.change();
  }

  // eslint-disable-next-line class-methods-use-this
  #conectarFacturaForm() {
    $('#editarFecha').click(() => {
      $('#show-fecha').hide();
      $('#form-fecha').removeClass('hide');
      return false;
    });

    $('#cancelarFecha').click(function cancelarFecha() {
      $(this).closest('form').addClass('hide').prev()
        .show();
      return false;
    });

    $('#editarObservaciones').click(function editarObservaciones() {
      $(this).parent().hide().next()
        .removeClass('hide');
      return false;
    });

    $('#cancelarObservaciones').click(function cancelarObservaciones() {
      $(this).closest('form').addClass('hide').prev()
        .show();
      $('#observaciones').val($('#currentObservaciones').text());
      return false;
    });

    $('#cancelarFormaPago').click(() => {
      const currentFormaPago = $('#currentFormaPago');
      $('.form-forma-pago').addClass('hide');
      currentFormaPago.show();
      $('#editarFormaPago').show();
      $('#forma_pago').val(currentFormaPago.data('id')).trigger('change');
      return false;
    });

    // Forma de pago
    $('#editarFormaPago').click(function editarFormaPago() {
      $(this).hide();
      $('#currentFormaPago').hide();
      $('.form-forma-pago').removeClass('hide');
      return false;
    });

    $('#metodo_pago_id').on('change', function cambiaMetodoPago() {
      if ($(this).find('option:selected').data('forma-pago-id') === Cifra.Conf.FORMA_PAGO_TRANSFERENCIA) {
        $('#cuenta').removeClass('hide');
      } else {
        $('#cuenta').addClass('hide');
      }
    });

    $('#enviarFactura').click(() => {
      set_overlay_ajax($('#modal-enviar-factura').find('.modal-content'));
    });

    $('#guardarObservaciones, #guardarFormaPago').on('click', () => {
      set_overlay_ajax($('#factura'));
    });

    $('#gestion_economica_factura_tag_list').on('change.select2', function changeTag(e) {
      // Select2 lanza el evento change dos veces, una al añadir el tag y otra al reordenar los tags
      // https://metabox.io/support/topic/select-advance-triggers-onchange-event-twice/
      const $select = $(this);
      if (!$select.data('select2-change-event')) {
        setTimeout(() => {
          $select.closest('form').submit();
          $select.removeData('select2-change-event');
        }, 50);
      }
      $select.data('select2-change-event', e);
    });
  }
}
